/* unplugin-vue-components disabled */import { render } from "./builder-summary.vue?vue&type=template&id=01b7bf20&scoped=true"
import script from "./builder-summary.vue?vue&type=script&lang=js"
export * from "./builder-summary.vue?vue&type=script&lang=js"

import "./builder-summary.vue?vue&type=style&index=0&id=01b7bf20&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b7bf20"],['__file',"src/components/builder/builder-summary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01b7bf20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01b7bf20', __exports__)) {
    api.reload('01b7bf20', __exports__)
  }
  
  module.hot.accept("./builder-summary.vue?vue&type=template&id=01b7bf20&scoped=true", () => {
    api.rerender('01b7bf20', render)
  })

}


export default __exports__